module.exports = __webpack_public_path__ + "img/porsche_2023.99d3d780.svg";